import { render, staticRenderFns } from "./insertTimeSaleInvoice.vue?vue&type=template&id=5ca4429c&"
import script from "./insertTimeSaleInvoice.vue?vue&type=script&lang=js&"
export * from "./insertTimeSaleInvoice.vue?vue&type=script&lang=js&"
import style0 from "./insertTimeSaleInvoice.vue?vue&type=style&index=0&id=5ca4429c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports